export const CONFLICT_STATUS_CODE = 409;
export const UNPROCESSIBLE_STATUS_CODE = 422;
export const NOT_FOUND_STATUS_CODE = 404;
export const UNAUTHORIZED_STATUS_CODE = 401;
export const INTERNAL_SERVER_STATUS_CODE = 500;
export const CLEAR_KEYWORD = "__CLEAR";
